import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CreatableSelect from "react-select/creatable";
import config from "../config.json";

export default class Company extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    campaigns: [],
    isEditMode: false,
    updatedCompany: {
      companyName: "",
      campaignId: "",
      companyKey: "",
      avatarId: "",
      maxAmountOfUserTeams: 0,
      subDivisions: [],
    },
  };

  componentDidMount() {
    this.setState({ updatedCompany: this.props.company });
    this.setState({ campaigns: this.props.campaigns });
  }

  handleCompanyEdit = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleEditSave = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateCompany(this.state.updatedCompany);
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      updatedCompany: {
        ...this.state.updatedCompany,
        [name]: value,
      },
    });
  };

  onCampaignChange = (event) =>
    this.setState({
      updatedCompany: {
        ...this.state.updatedCompany,
        campaignId: event.target.value,
      },
    });

  handleSubDivisionsChange = (selectedOptions) => {
    const subDivisions = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    this.setState({
      updatedCompany: {
        ...this.state.updatedCompany,
        subDivisions: subDivisions,
      },
    });
  };

  render() {
    return (
      <div className="tile is-child box notification">
        <Fragment>
          <a
            href="/"
            onClick={this.handleCompanyEdit}
            className="product-edit-icon"
          >
            <FontAwesomeIcon icon="edit" />
          </a>
          <button
            onClick={(event) =>
              this.props.handleDeleteCompany(this.props.company.id, event)
            }
            className="delete"
          ></button>
        </Fragment>

        {this.state.isEditMode ? (
          <div>
            <p className="product-id">id: {this.props.company.id}</p>
            <p>Navn</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedCompany.companyName}
              onChange={this.handleInputChange}
              name={"companyName"}
            />
            <p>Max antal bruger oprettede hold: </p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedCompany.maxAmountOfUserTeams}
              onChange={this.handleInputChange}
              name={"maxAmountOfUserTeams"}
            />

            <p>Company key</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedCompany.companyKey}
              onChange={this.handleInputChange}
              name={"companyKey"}
            />
            <div className="control">
              <select
                className="select is-medium"
                name="campaigns"
                id="campaigns"
                value={this.state.updatedCompany.campaignId}
                onChange={(e) => {
                  this.onCampaignChange(e);
                }}
              >
                {this.state.campaigns.map((campaign) => {
                  return (
                    <option key={campaign.id} value={campaign.id}>
                      {campaign.campaignName}
                    </option>
                  );
                })}
              </select>
              <p>Billede</p>
              <select
                name="avatarId"
                value={this.state.updatedCompany.avatarId}
                onChange={this.handleInputChange}
              >
                <option value=""></option>
                {this.props.organizationImages.map((organizationImage) => {
                  return (
                    <option
                      key={organizationImage.Key}
                      value={organizationImage.Key}
                    >
                      {organizationImage.Key}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="control">
              <label className="label">Underafdelinger:</label>
              <CreatableSelect
                isMulti
                value={this.state.updatedCompany.subDivisions?.map(
                  (division) => ({
                    value: division,
                    label: division,
                  })
                )}
                onChange={this.handleSubDivisionsChange}
                placeholder="Vælg eller indsæt underafdelinger"
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
            <button
              type="submit"
              className="button is-info is-small"
              onClick={this.handleEditSave}
            >
              Gem
            </button>
          </div>
        ) : (
          <div>
            {this.state.updatedCompany.avatarId && (
              <img
                className="organization-image"
                src={`${
                  config.s3.organizationImagesUrl +
                  this.state.updatedCompany.avatarId
                }`}
              />
            )}
            <p className="product-title">{this.props.company.companyName}</p>
            <p className="product-id">
              <b>Point:</b> {this.props.company.points.totalPoints}
            </p>
            <p className="product-id">
              <b>Gns point:</b> {this.props.company.avgTotalPoints}
            </p>
            <p className="product-id">
              <b>Antal brugere:</b> {this.props.company.campaignUsers?.length}
            </p>
            <p className="product-id">
              <b>Company key:</b> {this.props.company.companyKey}
            </p>
            <p className="product-id">
              <b>Max antal brugeroprettede hold:</b>
              {this.props.company.maxAmountOfUserTeams}
            </p>

            <p className="product-id">
              <b>Kg CO2:</b> {this.props.company.kgCO2}
            </p>
            <p className="product-id">
              <b>ID:</b> {this.props.company.id}
            </p>
            <p className="product-id">
              <b>Kampagne ID: </b>
              {this.props.company.campaignId}
            </p>
            <p className="product-id">
              <b>Underafdelinger: </b>
              {this.props.company.subDivisions &&
              this.props.company.subDivisions.length > 0
                ? this.props.company.subDivisions.join(", ")
                : "None"}
            </p>
          </div>
        )}
      </div>
    );
  }
}
